// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function unreachableCaseError(witness) {
    return new Error("unreachable");
}
//# sourceMappingURL=unreachableCaseError.js.map